<template>
  <div class="manage-account-tabs tenant-tabs">
    <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="firstTap"
          data-bs-toggle="tab"
          data-bs-target="#firstTapcontent"
          type="button"
          role="tab"
          aria-controls="firstTapcontent"
          aria-selected="true"
        >
          {{ $t('tenantTabs.rentCollection') }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link invoice-btn"
          id="secondTap"
          data-bs-toggle="tab"
          data-bs-target="#secondTapcontent"
          type="button"
          role="tab"
          aria-controls="secondTapcontent"
          aria-selected="false"
        >
          {{ $t('tenantTabs.invoices') }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="thirdTap"
          data-bs-toggle="tab"
          data-bs-target="#thirdTapcontent"
          type="button"
          role="tab"
          aria-controls="thirdTapcontent"
          aria-selected="false"
        >
          {{ $t('tenantTabs.maintenanceRequests') }}
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <!-- تحصيل الايجار-->
      <div
        class="tab-pane fade show active"
        id="firstTapcontent"
        role="tabpanel"
        aria-labelledby="firstTapcontent-tab"
      >
      <div v-if="Rents?.length">

        <div
          class="card-details-def pad-plus mb-3"
          v-for="rent in Rents"
          :key="rent.id"
        >
          <div class="flex-bet-main mb-3">
            <div class="gray-col">
              {{ $t('tenantTabs.dueDate') }} : <span class="color-main">{{ rent.day_date }}</span>
            </div>
            <div class="gray-col d-flex g-sm">
              {{ $t('tenantTabs.rentPayment') }} :
              <span class="color-red" :class="{ greenColor: rent.status_slug == 'paid' }"
                ><div v-if="rent.status_slug == 'notpaid'">{{ $t('tenantTabs.notPaid') }}</div>
                <div v-if="rent.status_slug == 'paid'">{{ $t('tenantTabs.paid') }}</div></span
              >
            </div>
          </div>
          <div class="flex-bet-main">
            <div class="gray-col">
              {{ $t('tenantTabs.rentValue') }} :
              <span class="color-main">{{ rent.price }} {{ $t('tenantTabs.currencyShort') }}</span>
            </div>
            <button class="main-btn up" v-if="rent.status_slug == 'notpaid'" >{{ $t('tenantTabs.markAsPaid') }}</button>
          </div>
        </div>
      </div>
  

        <div class="text-center" v-else>
          {{ $t('noData.noDataToShow') }}
        </div>
      </div>
      <!--الفواتير-->
      <div
        class="tab-pane fade"
        id="secondTapcontent"
        role="tabpanel"
        aria-labelledby="secondTapcontent-tab"
      >
        <div class="flex-end-main mb-3">
          <button class="main-btn up" @click="invoice = true">
            {{ $t('tenantTabs.addInvoice') }}
          </button>
        </div>
        <div class="card-details-def">
          <div
            class="flex-bet-file mb-3"
            v-for="invoice in invoices"
            :key="invoice.id"
          >
            <div class="flex-sm-gap">
              <div class="file-cont">
                <img :src="fileImg" class="fileImg" alt="" />
              </div>
              <div>{{ invoice.name }}</div>
            </div>
            <div>
              <!-- <div class="gray-col mb-2 font14">{{ invoice.created_at }}</div> -->

              <a
                :href="invoice.invoice"
                target="_blank"
                download
                class="downloadlink"
                >{{ $t('tenantTabs.downloadInvoice') }}</a
              >
            </div>
          </div>
        </div>
      </div>
      <!--طلبات الصيانة-->
      <div
        class="tab-pane fade"
        id="thirdTapcontent"
        role="tabpanel"
        aria-labelledby="thirdTapcontent-tab"
      >
        <div class="details-accordion" v-if="orders?.length">
          <div class="accordion" id="accordionExample">
            <div
              class="accordion-item mb-3"
              v-for="(order, i) in orders"
              :key="order.id"
            >
              <h2 class="accordion-header" :id="'heading' + i">
                <button
                  class="accordion-button collapsed font-bold black relative-parent d-block"
                  type="button"
                  @click="getOrderDetails(order.id)"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapse' + i"
                  aria-expanded="false"
                  :aria-controls="'collapse' + i"
                >
                  <div class="flex-bet-accordion mb-4">
                    <div class="font17 font-bold">
                      {{ $t('tenantTabs.orderNumber') }}: <span>{{ order.id }}</span>
                    </div>
                    <div class="gray-col normal-font">
                      {{ $t('tenantTabs.orderDate') }}:
                      <span class="color-main">{{ order.created_at }}</span>
                    </div>
                  </div>
                  <div class="flex-bet-accordion">
                    <div class="gray-col normal-font">
                      {{ $t('tenantTabs.maintenanceType') }}:
                      <span class="color-main">{{
                        order.maintenance_type.name
                      }}</span>
                    </div>
                  </div>
                </button>
              </h2>
              <div
                :id="'collapse' + i"
                class="accordion-collapse collapse"
                :aria-labelledby="'heading' + i"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body font15 pt-0">
                  <div class="gray-col normal-font mb-3">
                    {{ $t('tenantTabs.orderStatus') }}: <span>{{ order.status }}</span>
                  </div>
                  <div class="gray-col normal-font mb-1">{{ $t('tenantTabs.problemDescription') }}:</div>
                  <div class="mb-3">
                    {{ order.desc }}
                  </div>
                  <div class="flex-sm-gap no-align mb-4">
                    <div class="gray-col no-shrink">{{ $t('tenantTabs.technician') }}:</div>
                    <div class="content-all">
                      <div class="flex-sm-gap mb-2">
                        <div class="mb-2">{{ order.worker.name }}</div>
                        <div class="rating-sm-box">
                          <i class="fa-solid fa-star orange-col"></i>
                          <div>{{ order.worker.rate }}</div>
                        </div>
                      </div>
                      <div class="gray-col normal-font">
                        {{ $t('tenantTabs.phoneNumber') }}: <span>{{ order.worker.phone }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="gray-col mb-2" v-if="invoiceImg">{{ $t('tenantTabs.orderInvoice') }}:</div>
                  <div class="img-invoice">
                    <Image :src="invoiceImg" v-if="invoiceImg" alt="Image" preview />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" v-else>
          {{ $t('noData.noDataToShow') }}
        </div>
      </div>
    </div>
  </div>

  <Dialog v-model:visible="invoice" modal :style="{ width: '450px' }">
    <div class="modal-body-main modal-pad-main">
      <h6 class="text-center mb-4">{{ $t('tenantTabs.attachInvoice') }}</h6>
      <form @submit.prevent="addInvoice" ref="form">
        <div class="flex-group-me mb-3">
          <uploadFileSingle name="invoice" id="uploadbuildingpaper" />
        </div>

        <div class="flex-group-me">
          <button type="submit" :disabled="disabled" class="main-btn up lg">
            <div v-if="!disabled">{{ $t('tenantTabs.add') }}</div>
            <div class="loading" role="status" v-if="disabled">
              {{ $t('tenantTabs.adding') }}
              <div class="spinner-small-white" v-if="disabled"></div>
            </div>
          </button>
        </div>
      </form>
    </div>
  </Dialog>
</template>

<script setup>
// imports

import { onMounted, ref  , defineProps } from "vue";
import Image from "primevue/image";
import uploadFileSingle from "../dashboard/uploadFileSingle";
import Dialog from "primevue/dialog";
import axios from "axios";
import { useRoute } from "vue-router";
import { useToast } from "primevue/usetoast";
const toast = useToast();
const route = useRoute();


// props
const props = defineProps([
  "Rents",
]);

// reactive state
const invoices = ref([]);
const form = ref(null);
const disabled = ref(false);
// const Rents = ref([
//   {
//     id: 1,
//     date: "22/2/2020",
//     value: "20",
//     isPayed: true,
//   },
//   {
//     id: 2,
//     date: "22/2/2020",
//     value: "40",
//     isPayed: false,
//   },
// ]);
const fileImg = ref(require("@/assets/imgs/pdf.png"));
const invoice = ref(false);
const invoiceImg = ref('');

const orders = ref([]);
// functions
function getOrderDetails(id) {
  axios
    .get(`/manager/maintenance-order-details/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      invoiceImg.value = response.data.data.invoice;
    });
}
function getOrders() {
  axios
    .get(`/manager/maintenance-orders/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      orders.value = response.data.data;
    });
}
function getInvoices() {
  axios
    .get(`/manager/invoices/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      invoices.value = response.data.data;
    });
}

function addInvoice() {
  disabled.value = true;
  const fd = new FormData(form.value);

  fd.append("rental_id", route.params.id);

  axios
    .post("/manager/upload-invoice", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        invoice.value = false;
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        getInvoices();
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getInvoices();
  getOrders();
    console.log(props);
});
</script>
